/**
 * EnglishOnlyRoute - 内容页语言守卫。
 *
 * blog/guides/use-cases/法律文档（terms/privacy）等内容板块初始仅英文
 * （P1 决策，见计划 §决策3；法律文档 2026-08 起同样仅英文）。
 * 非 en 语言访问这些路径时，重定向到 /en 下的同路径，避免出现空内容页。
 *
 * 用法（页面组件内包裹，或 App.tsx 路由级）：
 *   <EnglishOnlyRoute><GuidesIndexPage/></EnglishOnlyRoute>
 *
 * 重定向保留子路径：/zh/guides/image-to-stl → /en/guides/image-to-stl
 */

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useLang, stripLang } from "../lib/lang";

export default function EnglishOnlyRoute({ children }: { children: ReactNode }) {
  const lang = useLang();
  const location = useLocation();

  if (lang !== "en") {
    // 用 stripLang 精确剥离已知语言前缀（比正则更稳健，不会误伤非语言首段），
    // 再拼 /en 前缀，保留子路径 + search + hash。
    const path = stripLang(location.pathname);
    const target = `/en${path}${location.search}${location.hash}`;
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
}
